'use client';

/**
 * useAuth.ts — offentlig hook for auth-state
 *
 * Tynn wrapper rundt useAuthContext() fra src/contexts/AuthContext.tsx.
 * Dette er den offentlige API-en komponenter bruker for å lese auth-state
 * og fullføre login (acceptLogin) / logout.
 *
 * Returnerer:
 * - user: innlogget bruker (AuthUser | null)
 * - loading: true under initialisering
 * - acceptLogin: (result, remember) => pending | null — lagrer token fra COMPLETE-svaret
 * - logout: () => void
 *
 * Bruk:
 *   const { user, loading, acceptLogin, logout } = useAuth();
 *   if (loading) return <LoadingSpinner />;
 *   if (!user) return <Login />;
 */

import { useAuthContext } from '@/contexts/AuthContext';

export function useAuth() {
  return useAuthContext();
}
